import { Inject, Injectable } from '@angular/core'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { HttpClient } from '@angular/common/http'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { Observable } from 'rxjs'
import { AuctionEntity, ContactOrganizerPayload } from './auction.models'

@Injectable({
  providedIn: 'root',
})
export class AuctionApiService extends GbBaseApiService {
  constructor(protected http: HttpClient, @Inject(APP_CONFIG) protected appConfig: any) {
    super(http, appConfig)
  }

  /**
   * get the auction from the API and return it WOW
   * @param urlName auction.url_name
   * @returns {list: [auction], uuid: auction.uuid}
   */
  getAuction(urlName: string | null): Observable<AuctionEntity> {
    return this.get(`auctions/${urlName}/`, { withCredentials: false })
  }

  contactOrganizer(urlName: string, payload: ContactOrganizerPayload): Observable<null> {
    const url = `auctions/${urlName}/contact-organizers/`
    return this.post(url, payload)
  }
}
